/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CTransactionReason {
    PURCHASE = 'Purchase',
    REFERRAL = 'Referral',
    MANUAL = 'Manual',
}
